const tags = {
    addedByUser: "addedByUser",
    user: "user",
    school: "school",
    dashboard: "dashboard",
}

export default tags;
